import React from 'react';
import { connect } from 'react-redux';
import { ErrorModal } from '../components/modals/error-modal';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'printPackingSlipPrintWarning.title',
    defaultMessage: 'Print Warning',
    id: 'YUAC48',
  },
  message: {
    description: 'printPackingSlipPrintWarning.message',
    defaultMessage: 'The packing slip for this shipment has already been printed. Reprint anyway?',
    id: 'tbCstw',
  },
  cancel: {
    description: 'printPackingSlipPrintWarning.cancel',
    defaultMessage: 'Cancel',
    id: 'l0Z/yE',
  },
  yes: {
    description: 'printPackingSlipPrintWarning.yes',
    defaultMessage: 'Yes, Reprint',
    id: 'UHuLbc',
  },
});

const mapStateToProps = (state, props) => {
  const { modalFrameworkMethods } = props;
  return {
    modalFrameworkMethods,
    state: 'warning',
    title: <FormattedMessage {...messages.title} />,
    message: <FormattedMessage {...messages.message} />,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { action, onYesClick } = props;
  return {
    buttons: [
      {
        theme: 'tertiary',
        children: <FormattedMessage {...messages.cancel} />,
      },
      {
        theme: 'primary',
        children: <FormattedMessage {...messages.yes} />,
        onClick:
          onYesClick ||
          (() => {
            dispatch({ ...action, override: true });
          }),
      },
    ],
  };
};

export const PrintPackingSlipPrintWarningContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
